import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@Store/index';
import {
  getAttendanceReasonsDict,
  getAttendanceStatusesDict,
  getAttendanceTypesDict,
} from '@Store/selectors/dictionarySelector';
import { prepareRequisitionInfo } from '@Utils/requisitionInfo';
import { transformDictToOptions } from '@Utils/transformToOptions';

import { allowedReasonsTechnicalIssue } from '../../constants';

const attendanceRequest = (state: RootState) =>
  state.featureStores.attendanceRequest;

const currentAttendanceRequest = createSelector(
  attendanceRequest,
  ({ attendanceRequest }) => attendanceRequest
);

const currentAttendanceLocation = createSelector(
  attendanceRequest,
  ({ attendanceLocation }) => attendanceLocation
);

const attendanceRequestCreateRequisitionInfo = createSelector(
  [currentAttendanceRequest, getAttendanceStatusesDict],
  (leaveRequest, leaveStatuses) => {
    const requisitionInfo = prepareRequisitionInfo(leaveRequest, leaveStatuses);
    return requisitionInfo;
  }
);

const getAttendanceTypeOptions = createSelector(
  getAttendanceTypesDict,
  (attendanceTypes) => transformDictToOptions(attendanceTypes)
);

const getAttendanceStatusLabels = createSelector(
  getAttendanceStatusesDict,
  (statuses) => statuses.map((status) => status.codeDesc)
);

const getAttendanceReasonLabels = createSelector(
  getAttendanceReasonsDict,
  (reasons) => reasons.map((item) => item.codeDesc)
);

const getAttendanceTechnicalIssueReasonLabels = createSelector(
  getAttendanceReasonsDict,
  (reasons) => {
    const output = reasons.filter(
      (reasonType) => allowedReasonsTechnicalIssue[reasonType.codeNum]
    ).map((item) => item.codeDesc);

    return output;
  },
);

export {
  currentAttendanceRequest,
  attendanceRequestCreateRequisitionInfo,
  currentAttendanceLocation,
  getAttendanceTypeOptions,
  getAttendanceStatusLabels,
  getAttendanceReasonLabels,
  getAttendanceTechnicalIssueReasonLabels,
};
